import React from 'react'
import "../Assets/styles/footer.css"
import { FaFacebook } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { FaInstagram } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";

const Copyright = () => {
  return (
    <>
        <div className="container-lg copy-all">
            <p>
                ©2024 Ignio
            </p>
            <div class="copy-right">
                {/* <a target="_blank" href="/#">
                <FaFacebook style={{height:'15px'}}/>
                </a> */}
                <a target="_blank" href="https://twitter.com/IgnioSupport">
                <BsTwitterX style={{height:'15px'}}/>
                </a>
                {/* <a target="_blank" href="/#">
                <FaInstagram style={{height:'15px'}}/>
                </a> */}
                <a target="_blank" href="https://www.linkedin.com/company/ignioteam">
                <CiLinkedin style={{height:'15px'}}/>
                </a>
            </div>
        </div>
    </>
  )
}
                    
export default Copyright